import styled from 'styled-components';
import colors from 'styles/colors';
import fonts from 'styles/fonts';
import media from 'styles/media';
import sizes from 'styles/sizes';
import { BrandCode } from 'types';

export const Card = styled.button`
	align-items: center;
	cursor: grab;
	outline: 0;
	padding: 0;
	margin: 0;
	font-family: ${fonts.primary.regular};
	display: flex;
	width: 410px;
	height: 100%;
	text-align: left;

	${({ theme, active }) =>
		({
			[BrandCode.Celebrity]: `
			border-width: 1px;
			border-style: solid;
			border-color: ${active ? colors.celebrity.blue : colors.celebrity.promoCardBorder};
      border-radius: 0;
      padding: 19px;
			background-color: ${active ? colors.celebrity.promoCardBackground : 'white'};
      `,
			[BrandCode.RoyalCaribbean]: `
			border-width: ${active ? '3px' : '1.5px'};
			border-style: solid;
			border-color: ${active ? 'black' : colors.functional.promoCardBorder};
	    border-radius: 5px;
      padding: 20px 15px;
    `,
		})[theme.brandCode]}

	${(props) => {
		if (props.disabled) {
			return `
      opacity: 0.5;
      pointer-events: none;
      `;
		}
	}}

  ${media.small`
    width: 100%;
    max-width:420px;
  `}
`;

export const IconContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;

	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `
      padding-right: 16px;
      border-right: 1px dashed ${colors.celebrity.promoCardBorder};
      min-height: 136px;
      `,
			[BrandCode.RoyalCaribbean]: `
      padding-right: 20px;
      border-right: 3px dashed ${colors.functional.promoCardBorder};
      min-height: 140px;
      svg {
		    width: 28px;
		    height: 28px;
	    }
    `,
		})[theme.brandCode]}

	@media (max-width: ${sizes.media.smallMaxWidth}px) {
		display: none;
	}
`;

export const Content = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	align-items: flex-start;
	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `
      padding-left: 16px;
      `,
			[BrandCode.RoyalCaribbean]: `
      padding-left: 20px;
    `,
		})[theme.brandCode]}
	@media (max-width: ${sizes.media.smallMaxWidth}px) {
		padding-left: 0px;
	}
`;

export const Applied = styled.span`
	text-transform: uppercase;
	display: block;
	margin-bottom: 10px;

	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `
      font-family: ${theme.typography.fontFamilySemiBold};
      font-size: 16px;
      color: ${colors.celebrity.blue};
      line-height: 8px;
      letter-spacing: 1.7px;
      `,
			[BrandCode.RoyalCaribbean]: `
      font-family: ${fonts.primary.bold};
      font-size: 12px;
      color: ${colors.secondary.deepCoveLight};
      line-height: 15px;
      letter-spacing: 1px;
    `,
		})[theme.brandCode]}
`;

export const Description = styled.span`
	font-size: 28px;
	text-transform: uppercase;
	display: block;
	padding-bottom: 5px;
	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `
      color: ${colors.celebrity.promoCardBlue};
      font-weight: 600;
      font-family: ${fonts.celebrity.neutraface};
      line-height: 28px;
      `,
			[BrandCode.RoyalCaribbean]: `
      color: ${colors.functional.pink};
      font-family: ${fonts.secondary.regular};
      line-height: 22px;
      `,
		})[theme.brandCode]}

	@media (max-width: ${sizes.media.smallMaxWidth}px) {
		${({ theme }) => (theme.brandCode === BrandCode.Celebrity ? 'font-size: 24px' : '')}
	}
`;

export const Perks = styled.span`
	font-size: 14px;
	strong {
		font-family: ${fonts.primary.bold};
	}
	margin-bottom: 10px;
	display: block;

	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `
      color: ${colors.celebrity.promoCardPerks};
      font-family: ${fonts.celebrity.poppins};
      line-height: 19.6px;
      `,
			[BrandCode.RoyalCaribbean]: `
      color: ${colors.secondary.deepCove};
      line-height: 17px;
    `,
		})[theme.brandCode]}
`;

export const Expires = styled.span`
	font-size: 12px;
	font-weight: ${(props) => (props.today ? 'bold' : 'normal')};
	color: ${(props) => (props.alert ? colors.functional.errorRed : colors.functional.softGrey)};
	display: block;

	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `
      font-family: ${fonts.celebrity.poppins};
      line-height: 12px;
      `,
			[BrandCode.RoyalCaribbean]: `
	    font-style: italic;
      line-height: 14px;
    `,
		})[theme.brandCode]}
`;

export const TermsAndConditions = styled.a`
	display: block;
	text-decoration: underline;

	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `
      font-family: ${fonts.celebrity.poppins};
      font-weight: 600;
      color: ${colors.celebrity.blue};
      font-size: 14px;
      margin-top: 16px;
      line-height: 19.6px;
      `,
			[BrandCode.RoyalCaribbean]: `
      color: ${colors.functional.blueButton};
      font-size: 12px;
      font-style: italic;
      line-height: 14px;
    `,
		})[theme.brandCode]}
`;
